import { render, staticRenderFns } from "./DeferredCommissionsTable.vue?vue&type=template&id=6453f7a2&scoped=true&"
import script from "./DeferredCommissionsTable.vue?vue&type=script&lang=js&"
export * from "./DeferredCommissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./DeferredCommissionsTable.vue?vue&type=style&index=0&id=6453f7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453f7a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
